<template>
  <v-overlay id="resimOnizle" :value="overlay" :opacity="0.85">
    <div>
      <div class="d-flex align-center justify-space-between mb-4">
        <p class="text-body-1 black--text mb-0">
          <v-icon class="onizle-icon" color="black" left>mdi-eye</v-icon>
          Önizleme
        </p>
        <v-btn icon color="black" @click="closeOverlay">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <div>
        <v-img id="resimOnizle-Preview" :src="img" max-width="800px"></v-img>
      </div>
      <div class="kapat-btn"></div>
    </div>
  </v-overlay>
</template>

<script>
export default {
  name: "ResimOnizle",
  data() {
    return {
      overlay: false,
    };
  },
  props: {
    img: {
      type: String,
      required: true,
      default: "",
    },
  },
  watch: {
    img() {
      if (this.img !== "") {
        this.overlay = true;
      }
    },
  },
  methods: {
    closeOverlay() {
      this.$emit("input", "");
      this.overlay = false;
    },
  },
};
</script>

<style>
#resimOnizle .v-overlay__scrim {
  background-color: #fff !important;
}
@media (max-width: 800px) {
  #resimOnizle .v-overlay__content {
    width: 100%;
  }
}
#resimOnizle-Preview {
  height: 90vh;
}
.onizle-icon {
  top: -2px;
}
</style>